module.exports = {
  "country": "UK",
  "artist": "Brotherhood of Man",
  "song": "Save your Kisses for me",
  "year": "1976",
  "place": "1",
  "spotify": "5OhwfIapBiHdIkxscQAcmq"
};